import React from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';

const propTypes = {
  children: PropTypes.string,
  text: PropTypes.string,
  data: PropTypes.object,
};
    
class Trans extends React.Component {
  static contextTypes = {
    language: PropTypes.string.isRequired,
    translations: PropTypes.object.isRequired,
    getTranslation: PropTypes.func.isRequired,
  }

  selector = createSelector(
    ({ text }) => text,
    ({ data }) => data,
    ({ language }) => language,
    (text, data) => {
      return this.context.getTranslation(text, data);
    }
  );

  transProcess = () => {
    const { children, text, data } = this.props;
    const { language } = this.context;      
    return this.selector({ text: text || children, data, language });
  }

  render() {
    return this.transProcess();
  }
}
    
Trans.propTypes = propTypes;
export default Trans;


// WEBPACK FOOTER //
// ./src/components/ui/Trans.jsx